<template>
  <div>
    <v-container fluid class="pa-0">
      <Monitor v-on:close-parent="closeParent"></Monitor>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "MonitorDetails",
  components: {
    Monitor: () => import("@/components/monitor/Monitor"),
  },
  methods: {
    closeParent: function () {
      this.$emit("close-parent");
    },
  },
};
</script>

<style scoped></style>
